import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function LoginPage() {
  const { login, signup } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [busy, setBusy] = useState(false);

  const next = sp.get("next") || "/";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (mode === "login") {
        const u = await login(form.email, form.password);
        toast.success("Welcome back");
        nav(u.role === "admin" ? "/admin" : next);
      } else {
        await signup(form);
        toast.success("Account created");
        nav(next);
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || "Failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <p className="eyebrow">{mode === "login" ? "Welcome back" : "Join the atelier"}</p>
      <h1 className="font-serif text-4xl mt-2">{mode === "login" ? "Sign in" : "Create an account"}</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        {mode === "signup" && (
          <>
            <input data-testid="auth-name" required placeholder="Full Name" value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} />
            <input data-testid="auth-phone" placeholder="Phone" value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} />
          </>
        )}
        <input data-testid="auth-email" required type="email" placeholder="Email" value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} />
        <input data-testid="auth-password" required type="password" placeholder="Password" value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} />
        <button data-testid="auth-submit" disabled={busy} className="btn-primary w-full disabled:opacity-60">{busy ? "Please wait…" : (mode === "login" ? "Sign In" : "Sign Up")}</button>
      </form>
      <p className="mt-6 text-sm text-stone-600">
        {mode === "login" ? "New here?" : "Already have an account?"}{" "}
        <button data-testid="auth-toggle" onClick={() => setMode(mode === "login" ? "signup" : "login")} className="underline">
          {mode === "login" ? "Create an account" : "Sign in"}
        </button>
      </p>
      <Link to="/" className="mt-4 block text-xs tracking-widest uppercase text-stone-500 hover:text-stone-900">← Back home</Link>
    </div>
  );
}
